// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminsPage_container__2lWu8"};